import { useContext, useImperativeHandle, useState } from "react";
import CreateNewWorkspaceModal from "./CreateNewWorkspaceModal";
import InviteMembersModal from "./InviteMembersModal";
import { toast } from "../../helper/common";
import useTranslator from "../../hooks/useTranslator";
import LandLordContext from "../../context/landlord/LandLordContext";
import AuthContext from "../../context/auth/AuthContext";
import { haveValue } from "../../helper/common";
import InvitationsCustomization from "./InvitationsCustomization";
import { Modal } from "react-bootstrap";

const NewWorkspaceLayout = (props) => {
  const { _t } = useTranslator();
  const { user, loadUserTenant } = useContext(AuthContext);
  const { addNewWorkspace } = useContext(LandLordContext);

  const {
    setCloseState,
    setOpenWelcomeModal,
    setTempWorkspaceData,
    workspaceName,
    setWorkspaceName,
    currentStep,
    openWorkspaceModal,
    setOpenWorkspaceModal,
    openInviteModal,
    setOpenInviteModal,
    setShouldCreateWorkspace,
    childRef,
  } = props;

  const [disableButtons, setDisableButtons] = useState(false);

  const [invitationWorkspaceData, setInvitationWorkspaceData] = useState({
    customLinkEnabled: false,
    customLinkSlug: "",
    invitationLogo: null,
    protectedHousing: false,
    affidavitActivated: false,
    dea_rules_activated: false,
  });

  const [openInvitationCustomization, setOpenInvitationCustomization] =
    useState(false);

  const [memberData, setMemberData] = useState([
    {
      email: "",
      role: "",
    },
  ]);

  const [workspaceImage, setWorkspaceImage] = useState(null);
  const [defaultEffortRate, setDefaultEffortRate] = useState(35);

  const handleAddMember = () => {
    setMemberData((prev) => [...prev, { email: "", role: "" }]);
  };

  const handleRemoveMember = (indexToRemove) => {
    setMemberData((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  const closeWorkspaceModal = () => {
    setCloseState(false);
  };

  console.log(invitationWorkspaceData, "invitationWorkspaceData");

  const handleSubmit = () => {
    const validMembers = [];

    setDisableButtons(true);

    for (let i = 0; i < memberData.length; i++) {
      const { email, role } = memberData[i];

      const hasEmail = email.trim() !== "";
      const hasRole = role.trim() !== "";

      if ((hasEmail && !hasRole) || (!hasEmail && hasRole)) {
        toast.error(_t("emailSlashRoleCannotBeEmpty"));
        setDisableButtons(false);
        return;
      }

      if (hasEmail && hasRole) {
        validMembers.push({
          email: email.trim(),
          role: role.trim(),
        });
      }
    }

    if (!user?.tourCompleted) {
      setShouldCreateWorkspace(false);
      props?.goToStepSix();
    }

    const sendData = {
      name: workspaceName,
      members: validMembers,
      default_effort_rate: defaultEffortRate,
    };

    const formData = new FormData();

    formData.append("name", workspaceName);
    formData.append("members", JSON.stringify(validMembers));
    formData.append("default_effort_rate", defaultEffortRate);

    // Workspace Image
    if (haveValue(workspaceImage?.uploadedFile)) {
      formData.append("profileImage", workspaceImage?.uploadedFile);
    } else if (haveValue(workspaceImage?.selectedAvatarIndex)) {
      formData.append(
        "imageUrl",
        `DefaultWorkspace${workspaceImage?.selectedAvatarIndex}.png`
      );
    }

    // Invitation customization
    formData.append(
      "customLinkEnabled",
      invitationWorkspaceData?.customLinkEnabled
    );

    if (invitationWorkspaceData?.customLinkEnabled) {
      formData.append(
        "customLinkSlug",
        invitationWorkspaceData?.customLinkSlug
      );
    }

    if (invitationWorkspaceData?.invitationLogo) {
      formData.append(
        "invitationLogo",
        invitationWorkspaceData?.invitationLogo
      );
    }

    formData.append(
      "affidavit_activated",
      invitationWorkspaceData?.affidavitActivated
    );
    formData.append(
      "dea_rules_activated",
      invitationWorkspaceData?.dea_rules_activated
    );
    formData.append(
      "protected_housing_enabled",
      invitationWorkspaceData?.protectedHousing
    );
    addNewWorkspace(formData)
      .then(() => {
        toast.success(_t("workspaceCreatedAndMembersInvited"));

        closeWorkspaceModal();
        setOpenWelcomeModal(true);
        setTempWorkspaceData(sendData);

        setDisableButtons(false);
        loadUserTenant("landlord");
      })
      .catch((err) => {
        console.log(err);
        toast.error(_t("errorWhileCreatingWorkspaceOrInvitingMembers"));
        setDisableButtons(false);
      });
  };

  useImperativeHandle(childRef, () => ({
    handleSubmit,
  }));

  const handleGoBackToName = () => {
    // setOpenInviteModal(false);
    setOpenInvitationCustomization(false);
    setWorkspaceImage(null);
    setOpenWorkspaceModal(true);
  };
  const handleGoBackToInviteCustomization = () => {
    setOpenInviteModal(false);
    setWorkspaceImage(null);
    setOpenInvitationCustomization(true);
  };

  const handleOpenInviteModal = () => {
    setOpenInvitationCustomization(false);
    setOpenInviteModal(true);
  };

  return (
    <>
      <CreateNewWorkspaceModal
        isOpen={openWorkspaceModal}
        onClose={closeWorkspaceModal}
        setOpenWorkspaceModal={setOpenWorkspaceModal}
        // setOpenInviteModal={setOpenInviteModal}
        setOpenInvitationCustomization={setOpenInvitationCustomization}
        setWorkspaceName={setWorkspaceName}
        workspaceName={workspaceName}
        setWorkspaceImage={setWorkspaceImage}
        defaultEffortRate={defaultEffortRate}
        setDefaultEffortRate={setDefaultEffortRate}
        goToPrevStep={props.goToPrevStep}
        goToStepFive={props.goToStepFive}
        currentStep={currentStep}
      />
      {/* <InvitationsCustomization
        actionType="create"
        invitationWorkspaceData={invitationWorkspaceData}
        setInvitationWorkspaceData={setInvitationWorkspaceData}
        handleSubmit={handleOpenInviteModal}
        disableButtons={disableButtons}
      /> */}

      {openInvitationCustomization && (
        <Modal
          show={openInvitationCustomization}
          onHide={() => {
            setOpenInvitationCustomization(false);
            setOpenWorkspaceModal(true);
          }}
          className="newmodalui max-w-lg tailwind-base-modal wrapper-modal newWorkspaceModal manageWorkspaceModalWrapper"
        >
          <InvitationsCustomization
            actionType="create"
            invitationWorkspaceData={invitationWorkspaceData}
            setInvitationWorkspaceData={setInvitationWorkspaceData}
            handleSubmitFromParent={handleOpenInviteModal}
            disableButtons={disableButtons}
            handleGoBackToName={handleGoBackToName}
          />
        </Modal>
      )}
      <InviteMembersModal
        isOpen={openInviteModal}
        goToStepFive={props.goToStepFive}
        goToStepFour={props.goToStepFour}
        onClose={closeWorkspaceModal}
        setMemberData={setMemberData}
        memberData={memberData}
        handleAddMember={handleAddMember}
        handleSubmit={handleSubmit}
        handleGoBackToInviteCustomization={handleGoBackToInviteCustomization}
        disableButtons={disableButtons}
        workspaceName={workspaceName}
        handleRemoveMember={handleRemoveMember}
        goToPrevStep={props.goToPrevStep}
        goToStepSix={props.goToStepSix}
      />
    </>
  );
};

export default NewWorkspaceLayout;
